import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
    selector: 'ag-grid-loading-overlay',
    template: `<ws-ace-loader></ws-ace-loader>`,
    styleUrls: ['./agGridLoadingOverlay.component.scss'],
    standalone: false
})
export class AgGridLoadingOverlayComponent implements ILoadingOverlayAngularComp {

    agInit(params: ILoadingOverlayParams): void {
        return null;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
